import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { PrestamosModel, DeudaACortoPlazoPrestamosModel } from './prestamos.model';
import { PrestamosListComponent } from './prestamos-list.component';
import { PrestamosService } from './prestamos.service';
import { ActivityModel } from '../../user/activity/activity.model';
import { ActivityService } from '../../user/activity/activity.service';

@Component({
    selector: 'convfact-prestamosdeudaacortoplazo',
    templateUrl: './prestamos-dialog-deuda-a-corto-plazo.component.html',
    styleUrls: ['./prestamos.component.css'],
    standalone: false
})
export class PrestamosDialogDeudaACortoPlazoComponent implements OnInit {

  public prestamos: PrestamosModel = this.data.prestamos;

  public deudaACortoPlazoPrestamos: DeudaACortoPlazoPrestamosModel = new DeudaACortoPlazoPrestamosModel();

  public depositSaved: boolean = false;

  public ready: boolean = false;

  public isEditMode: boolean = false;

  public list: boolean = false;

  public dataSource: DeudaACortoPlazoPrestamosModel[] = [];
  public headerTable: any[] = [
    { field: 'fecha', title: 'Fecha', cell: (row) => `${new Date(row.fecha).toLocaleDateString()}`, class: (row) => `` },
    { field: 'concepto', title: 'Concepto', cell: (row) => `${row.concepto}  `, class: (row) => `` },
    { field: 'importe', title: 'Importe', cell: (row) => `${row.importe}  `, class: (row) => `` },
  ];

  public invalidDate: boolean = false;
  public invalidConcept: boolean = false;
  public invalidImporte: boolean = false;

  public activities: ActivityModel[] = [];

  constructor(
    public dialogRef: MatDialogRef<PrestamosListComponent>,
    public prestamosService: PrestamosService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public activityService: ActivityService,
  ) { }

  public ngOnInit(): void {
    this.activityService.getList()
      .then(response => {
        this.activities = response;
      });

    this.getData();
  }

  public pay(): void {
    // Asignamos el uid al deposito
    this.deudaACortoPlazoPrestamos.prestamosId = this.prestamos.uid;

    let noError: boolean = true;

    // Validations
    if (this.deudaACortoPlazoPrestamos.fecha == null) {
      noError = false;
      this.invalidDate = true;
    }

    if (this.deudaACortoPlazoPrestamos.concepto == null || this.deudaACortoPlazoPrestamos.concepto == '') {
      noError = false;
      this.invalidConcept = true;
    }

    if (this.deudaACortoPlazoPrestamos.importe == null || this.deudaACortoPlazoPrestamos.importe == 0) {
      noError = false;
      this.invalidImporte = true;
    }

    if (this.deudaACortoPlazoPrestamos.activitiesUid == null) {
      noError = false;
    }

    // Request
    if (noError) {
      if (this.isEditMode === false) {
        this.prestamosService.deudaACortoPlazoCreate(this.deudaACortoPlazoPrestamos)
          .then(response => {
            this.depositSaved = true;
          })
          .catch(err => {
            this.displayInfo("Ha ocurrido un error inesperado al añadir el elemento");
          });
      }
      if (this.isEditMode === true) {
        this.prestamosService.deudaACortoPlazoUpdate(this.deudaACortoPlazoPrestamos)
          .then(response => {
            this.depositSaved = true;
          })
          .catch(err => {
            this.displayInfo("Ha ocurrido un error inesperado al actualizar el elemento");
          });
      }
    } else {
      this.displayInfo("Compruebe que tiene los campos rellenados correctamente");
    }

  }

  public getData(): void {
    this.depositSaved = false;
    this.ready = false;

    this.invalidDate = false;
    this.invalidConcept = false;
    this.invalidImporte = false;

    this.prestamosService.deudaACortoPlazoList(this.prestamos.uid)
      .then(response => {
        this.dataSource = response;

        if (this.dataSource.length > 0) {
          this.list = true;
        }
        this.ready = true;
      })
      .catch(error => {
        this.ready = true;
      });
  }

  public delete(uidElement: string): void {
    // Este uid es el id
    this.prestamosService.deudaACortoPlazoDelete(uidElement)
      .then(response => {
        this.getData();
      })
      .catch(err => {
        this.displayInfo("Ha ocurrido un error al eliminar el elemento");
      });
  }

  public edit(uidElement: string): void {
    const elementSearched = this.dataSource.find(f => f.uid == uidElement);

    this.isEditMode = true;
    this.depositSaved = false;

    this.deudaACortoPlazoPrestamos = elementSearched;
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }
  public trackByIndex(i: number) { return i; }

}
